// removed by extract-text-webpack-plugin
module.exports = {"boooi":"boooi__3QSI4","mdc-menu-anchor":"mdc-menu-anchor__2jKQX","booi":"booi__1bOv1","booi2":"booi2__2nn_l","boooooi":"boooooi__1HOwO","link":"link__2n585"};


//////////////////
// WEBPACK FOOTER
// ./components/user/style.css
// module id = Pj5f
// module chunks = 12